// TelcoTrack — stav uživatele v HR adresáři (seznam Uživatelé).

export const USER_DIRECTORY_STATUSES = ['aktivni', 'archiv'] as const;

export type UserDirectoryStatus = (typeof USER_DIRECTORY_STATUSES)[number];

export const USER_DIRECTORY_STATUS_LABELS_CS: Record<UserDirectoryStatus, string> = {
  aktivni: 'Aktivní',
  archiv: 'Archiv',
};

/** Filtr seznamu uživatelů — výchozí jen aktivní. */
export type UserDirectoryStatusFilter = UserDirectoryStatus | 'vse';

export const USER_DIRECTORY_STATUS_FILTER_OPTIONS_CS: ReadonlyArray<{
  value: UserDirectoryStatusFilter;
  label: string;
}> = [
  { value: 'aktivni', label: USER_DIRECTORY_STATUS_LABELS_CS.aktivni },
  { value: 'archiv', label: USER_DIRECTORY_STATUS_LABELS_CS.archiv },
  { value: 'vse', label: 'Vše' },
];

export function normalizeUserDirectoryStatus(raw: unknown): UserDirectoryStatus {
  const key = String(raw ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
  if (key === 'archiv' || key === 'archived') return 'archiv';
  return 'aktivni';
}

export function normalizeUserDirectoryStatusFilter(raw: unknown): UserDirectoryStatusFilter {
  const key = String(raw ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
  if (key === 'archiv' || key === 'archived') return 'archiv';
  if (key === 'vse' || key === 'all') return 'vse';
  if (key === 'aktivni' || key === 'active' || key === '') return 'aktivni';
  return 'aktivni';
}

export function userDirectoryStatusLabelCs(status: UserDirectoryStatus | null | undefined): string {
  if (!status) return USER_DIRECTORY_STATUS_LABELS_CS.aktivni;
  return USER_DIRECTORY_STATUS_LABELS_CS[status] ?? USER_DIRECTORY_STATUS_LABELS_CS.aktivni;
}
